<form [formGroup]="mainForm" (ngSubmit)="onSubmit(mainForm)" novalidate (keydown.enter)="$event.preventDefault()">
  <div #contentContainer class="container-fluid" [ngClass]="{'style-25': usaTema == '25'}">
    <div *ngIf="usaTema != ''" class="row">
      <mat-form-field class="col">
        <input matInput placeholder="Azienda" type="text" i18n-placeholder="@@FormCompanyPlaceholder" formControlName="company">
        <mat-error *ngIf="mainForm.get('company').hasError('required')" i18n="@@FormCompanyRequired">
          L'azienda è
          <strong>obbligatoria</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="formField col">
        <input matInput placeholder="Nome" type="text" i18n-placeholder="@@FormFirstNamePlaceholder" formControlName="firstName">
        <mat-error *ngIf="mainForm.get('firstName').hasError('required')" i18n="@@FormFirstNameRequired">
          Il nome è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="formField col">
        <input matInput placeholder="Cognome" type="text" i18n-placeholder="@@FormSurnamePlaceholder" formControlName="surname">
        <mat-error *ngIf="mainForm.get('surname').hasError('required')" i18n="@@FormSurnameRequired">
          Il cognome è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="col formField">
        <input type="text" placeholder="Nazione" matInput i18n-placeholder="@@FormCountryPlaceholder" formControlName="country" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let country of filteredCountries | async" [value]="country">
            {{ country.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="mainForm.get('country').hasError('required')" i18n="@@FormCountryRequired">
          La nazione è
          <strong>obbligatoria</strong>
        </mat-error>
        <mat-error *ngIf="mainForm.get('country').hasError('isObject') && !mainForm.get('country').hasError('required')" i18n="@@FormCountryNotFound">
          Nazione
          <strong>non trovata</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="formField col">
        <input matInput placeholder="Professione" type="text" i18n-placeholder="@@FormJobPlaceholder" formControlName="job">
        <!-- <mat-hint>Professione del richiedente</mat-hint> -->
        <mat-error *ngIf="mainForm.get('job').hasError('required')" i18n="@@FormJobRequired">
          La professione è
          <strong>obbligatoria</strong>
        </mat-error>
        <mat-icon *ngIf="usaTema == ''" matSuffix>work</mat-icon>
      </mat-form-field>
    </div>
    <div class="row" [ngClass]="{'altezza-riga': usaTema == '25'}">
      <div class="col ">
        <label style="margin-right: 20px" i18n="@@FormSectorPlaceholder">Settore</label>
        <mat-radio-group formControlName="sector">
          <mat-radio-button checked="true" value="0" i18n="@@FormSectorCarRepair" style="margin-right: 10px">Autoriparazione</mat-radio-button>
          <mat-radio-button value="1" i18n="@@FormSectorIndustry" style="margin-right: 10px">Industria</mat-radio-button>
          <mat-radio-button value="2" i18n="@@FormSectorHandicraft" style="margin-right: 10px">Artigianato</mat-radio-button>
          <mat-radio-button value="3" i18n="@@FormSectorPrivate" style="margin-right: 10px">Privato</mat-radio-button>
        </mat-radio-group>
      </div>
      <mat-form-field  *ngIf="usaTema == ''"  class="col">
        <input matInput placeholder="Azienda" type="text" i18n-placeholder="@@FormCompanyPlaceholder" formControlName="company">
        <mat-error *ngIf="mainForm.get('company').hasError('required')" i18n="@@FormCompanyRequired">
          L'azienda è
          <strong>obbligatoria</strong>
        </mat-error>
        <mat-icon *ngIf="usaTema == ''"  matSuffix>work</mat-icon>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="col" [ngClass]="{'formField': usaTema != ''}">
        <textarea matInput formControlName="note" placeholder="Note" i18n-placeholder="@@FormNotePlaceholder" maxlength="255" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="5"></textarea>
        <mat-hint i18n="@@FormNoteHint">Note facoltative</mat-hint>
        <mat-icon *ngIf="usaTema == ''"  matSuffix>mode_edit</mat-icon>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="formField col">
        <input matInput placeholder="E-Mail" type="text" i18n-placeholder="@@FormMailPlaceholder" formControlName="email">
        <mat-error *ngIf="mainForm.get('email').hasError('email') && !mainForm.get('email').hasError('required')" i18n="@@FormMailInvalid">
          L'indirizzo e-mail inserito non è
          <strong>valido</strong>
        </mat-error>
        <mat-error *ngIf="mainForm.get('email').hasError('required')" i18n="@@FormMailRequired">
          L'indirizzo e-mail è
          <strong>obbligatorio</strong>
        </mat-error>
        <mat-icon *ngIf="usaTema == ''"  matSuffix>mail</mat-icon>
      </mat-form-field>
      <mat-form-field class="formField col">
        <input matInput placeholder="Telefono" type="text" i18n-placeholder="@@FormPhonePlaceholder" formControlName="phone">
        <mat-icon *ngIf="usaTema == ''"  matSuffix>phone</mat-icon>
        <mat-hint i18n="@@FormPhoneHint">Numero di telefono del richiedente</mat-hint>
        <mat-error *ngIf="mainForm.get('phone').hasError('required')" i18n="@@FormPhoneRequired">
          Il numero di telefono è
          <strong>obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row" style="margin-top: 1px">
      <div class="col">
        <label style="margin-right: 20px" i18n="@@FormContactMethod">Metodo preferito di contatto</label>
        <mat-radio-group formControlName="contactMethod">
          <mat-radio-button style="margin-right: 20px" value="0" checked="true" i18n="@@FormContactMethodMail">E-Mail</mat-radio-button>
          <mat-radio-button value="1" i18n="@@FormContactMethodPhone">Telefono</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="row" style="margin-top: 15px">
      <mat-checkbox class="formField col" formControlName="canContact" i18n="@@FormCanContactText">Ho preso visione della
        <a href="https://www.beta-tools.com/{{lang}}/privacy-policy/" target="_blank">privacy policy</a>
        <br *ngIf="usaTema == ''" /> e autorizzo il trattamento secondo l’articolo 2B *</mat-checkbox>
    </div>
    <hr  *ngIf="usaTema == ''" />
    <div [ngClass]="{'formField': usaTema == ''}" class="row riga-bottone" [style.text-align]="usaTema == '' ? 'right' : 'center'">
      <div class="col">
        <!-- <button *ngIf="!isProduction" mat-raised-button type="button" color="default" (click)="testData()" >Test data</button> -->
        <button *ngIf="usaTema == ''" mat-raised-button type="submit" color="primary" [disabled]="!mainForm.valid" i18n="@@FormSubmitButton">Invia richiesta di contatto</button>
        <div  *ngIf="usaTema != ''" class="btn-box">
          <button type="submit" [disabled]="!mainForm.valid" class="submit-btn" [ngClass]="{'btn-disabled': mainForm.valid == false}"  >
              <span i18n="@@FormSubmitButton25">INVIA RICHIESTA</span>
              <svg height="25px" width="25px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-72.67 -72.67 372.44 372.44"
                  xml:space="preserve" fill="#000000" stroke="#000000" stroke-width="6.81288" [ngClass]="{'svg-white': mainForm.valid == true}">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                      <g>
                          <g>
                              <polygon style="fill:#010002;"
                                  points="152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 146.933,181.902 152.835,187.811 227.096,113.55 ">
                              </polygon>
                          </g>
                      </g>
                  </g>
              </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
<!--
  <pre *ngIf="!isProduction">
    <p>Form value: {{ mainForm.value | json }}</p>
    <p>Form status: {{ mainForm.status | json }}</p>
    <p>Form valid: {{ mainForm.valid }}</p>
  </pre>
-->
</form>
<app-busy-spinner *ngIf="isLoading"></app-busy-spinner>



// WEBPACK FOOTER //
// ./src/app/app.component.html